/**
 * StaffData 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { StaffInfo } from './staff_info'
import type { StaffRoleInfo } from './staff_role_info'
import type { StaffStatsData } from './staff_stats_data'

/**
 * StaffData
 */
export interface StaffData {
  /** 员工ID */
  id?: string
  /** 员工基础信息 */
  info?: StaffInfo
  /** 角色列表 */
  roles?: StaffRoleInfo[]
  /** 统计信息 */
  stats?: StaffStatsData
}

/**
 * StaffData Schema
 */
export const StaffDataSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '员工ID',
      format: 'string',
      type: 'string',
      label: '员工ID',
    },
    info: {
      $ref: 'StaffInfo',
      description: '员工基础信息',
      label: '员工基础信息',
    },
    roles: {
      description: '角色列表',
      format: '[]*entity.StaffRoleInfo',
      items: { $ref: 'StaffRoleInfo', description: '' },
      type: 'array',
      label: '角色列表',
    },
    stats: {
      $ref: 'StaffStatsData',
      description: '统计信息',
      label: '统计信息',
    },
  },
  type: 'object',
}
